export const PAYROLL_DEDUCTION_FETCH_TAX = 'PAYROLL_DEDUCTION_FETCH_TAX';
export const PAYROLL_DEDUCTION_FETCH_TAX_SUCCESS = 'PAYROLL_DEDUCTION_FETCH_TAX_SUCCESS';
export const PAYROLL_DEDUCTION_FETCH_TAX_FAILURE = 'PAYROLL_DEDUCTION_FETCH_TAX_FAILURE';

export const PAYROLL_DEDUCTION_SAVE_TAX = 'PAYROLL_DEDUCTION_SAVE_TAX';
export const PAYROLL_DEDUCTION_SAVE_TAX_SUCCESS = 'PAYROLL_DEDUCTION_SAVE_TAX_SUCCESS';
export const PAYROLL_DEDUCTION_SAVE_TAX_FAILURE = 'PAYROLL_DEDUCTION_SAVE_TAX_FAILURE';

export const PAYROLL_DEDUCTION_CHANGE_TAX_STATUS = 'PAYROLL_DEDUCTION_CHANGE_TAX_STATUS';
export const PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_SUCCESS = 'PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_SUCCESS';
export const PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_FAILURE = 'PAYROLL_DEDUCTION_CHANGE_TAX_STATUS_FAILURE';
